// Low-attention support affordance. Small "?" circle at bottom-right.
// Tap reveals a one-line note that says we have a Telegram bot — only
// surfaced on demand so it doesn't push casual users into messaging.
// Goal: when someone hits a problem they shouldn't have to hunt for
// where to ask; when nothing is wrong they shouldn't notice it at all.

import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { HelpCircle, Send } from "lucide-react";
import { useT } from "@/lib/i18n";

const TELEGRAM_URL = "https://t.me/taklifla_bot";

export function SupportChip() {
  const t = useT();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const wrapRef = useRef<HTMLDivElement>(null);

  const path = location.pathname;
  const hide =
    path === "/login" ||
    path.startsWith("/checkout/") ||
    path.includes("/edit") ||
    path.startsWith("/i/") ||
    /^\/[a-z0-9]{5}\/[a-z0-9-]+$/.test(path);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  useEffect(() => {
    if (!open) return;
    const onDoc = (e: MouseEvent) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, [open]);

  if (hide) return null;

  return (
    <div ref={wrapRef} className="tk-support">
      {open && (
        <div role="dialog" aria-label={t("support.aria", "Yordam")} className="tk-support__pop">
          <p style={{ margin: 0 }}>
            {t(
              "support.note",
              "Muammo bo'lsa, Telegram orqali yozing:",
            )}
          </p>
          <a href={TELEGRAM_URL} target="_blank" rel="noopener" className="tk-link">
            @taklifla_bot
            <Send size={15} strokeWidth={1.7} aria-hidden="true" />
          </a>
        </div>
      )}
      <button
        type="button"
        className="tk-support__fab"
        onClick={() => setOpen((v) => !v)}
        aria-label={t("support.aria", "Yordam")}
        aria-expanded={open}
        title={t("support.aria", "Yordam")}
      >
        <HelpCircle size={20} strokeWidth={1.6} aria-hidden="true" />
      </button>
    </div>
  );
}
